// src/services/departmentService.js
import { api } from './api';

const transformDept = (dept) => ({
  id: dept.department_code,          // department_code hi unique identifier hai
  department_code: dept.department_code,
  name: dept.department_name,
  head: dept.manager_name,
  description: dept.description || '',
  total_employees: dept.total_employees || 0,
  created_at: dept.created_at,
});

export const departmentService = {
  getDepartments: async () => {
    const response = await api.get('/api/departments');
    const data = response?.data || response || [];
    const list = Array.isArray(data) ? data : [];
    return { data: list.map(transformDept) };
  },

  createDepartment: async (data) => {
    const response = await api.post('/api/departments', data);
    return { data: transformDept(response?.data || response) };
  },

  updateDepartment: async (departmentCode, data) => {
    const response = await api.put(`/api/departments/${departmentCode}`, data);
    return { data: transformDept(response?.data || response) };
  },

  deleteDepartment: async (departmentCode) => {
    return await api.delete(`/api/departments/${departmentCode}`);
  },
};